<template>
    <div class="box-wrap">
        <div class="brian">
            <BrianThumbs/>
        </div>
        <div class="box">
            <p>Sådan, nu er du klar til at komme på Vorbasse hjemmemarked.</p>
	        <button @click="$router.push('/')" class="big"><template v-if="new Date().getTime() > 1594893600000">Kom indenfor!</template><template v-else>Vi glæder os til at se dig</template></button>
            <div class="cards">
                <img class="img-responsive" src="@/assets/cards.png" />
            </div>
        </div>
    </div>
</template>

<script>
	import BrianThumbs from "@/assets/login/brian-thumbs.svg"
	export default {
		name: "KomIndenfor",
        components: {
	        BrianThumbs
        }
	}
</script>

<style lang="scss" scoped>
    .box-wrap{
        padding-top: 375px !important;
        .brian{
            transform: translateX(-62%) !important;
        }
    }
</style>
